import { getAvailableBrowserLocale } from './normalize'

export function source(name, read, { validate = true, when } = {}) {
  return { name, read, validate, when }
}

export function group(name, priority, when) {
  return { name, priority, when }
}

export function stored() {
  return source('stored', (context) => context.storedLocale)
}

export function path() {
  return source('path', (context) => context.urlLocale)
}

export function browser() {
  return source('browser', (context) =>
    getAvailableBrowserLocale(context.languages, context.language, context.availableLocales),
  )
}

export function bot() {
  return source('bot', (context) => (context.isBot ? context.defaultLocale : null), { validate: false })
}

export function defaultLocale() {
  return source('default', (context) => context.defaultLocale, { validate: false })
}
